import {actionCheck} from "@intellectability/platform-common/utils";
import {UserDetails, UserNotifications, UserTraining, UserTrainingNotes} from "./index.js";
import {ACTIONS} from "@intellectability/platform-common/constants";
import {userSecurity} from "@intellectability/platform-common/sv/state";
import UserOnePageDescription from "./Tabs/UserOnePageDescription.svelte";

const {
    USER_TAB_DETAILS_VIEW,
    USER_TAB_NOTIFICATIONS_VIEW,
    USER_TAB_TRAININGS_VIEW,
    USER_ONE_PAGE_DESCRIPTION_VIEW,
    USER_TRAINING_NOTES_EDIT,
    USER_TRAINING_NOTES_VIEW_OWN
} = ACTIONS;

let hasAccess = $derived(actionCheck(userSecurity.userActions));

let profileTabs = $derived([
    {
        component: UserDetails,
        icon: "id-card",
        key: "details",
        show: [USER_TAB_DETAILS_VIEW],
        title: "Details",
        lazyLoad: true
    },
    {
        component: UserNotifications,
        icon: "comment-lines",
        iconClass: "fa-flip-horizontal",
        key: "notifications",
        show: [USER_TAB_NOTIFICATIONS_VIEW],
        title: "Notifications",
        lazyLoad: true
    },
    {
        component: UserTraining,
        icon: "graduation-cap",
        key: "trainings",
        title: "Trainings",
        show: [USER_TAB_TRAININGS_VIEW],
        lazyLoad: true
    },
    {
        component: UserOnePageDescription,
        icon: "file-user",
        key: "one_page_description",
        show: [USER_ONE_PAGE_DESCRIPTION_VIEW],
        title: "One Page Description",
        lazyLoad: true
    },
    {
        component: UserTrainingNotes,
        icon: "chalkboard-teacher",
        key: "training_notes",
        show: [USER_TRAINING_NOTES_EDIT, USER_TRAINING_NOTES_VIEW_OWN],
        title: "Training Notes",
        lazyLoad: true
    }
]);

export function getProfileTabs(isOwnProfile = false) {

    return profileTabs.filter(function (tab) {

        // well, sadly, the training_notes tab depends on an additional check besides actions
        if (tab.key === "training_notes") {
            // check has access on first element and with profile ownership on the second
            return hasAccess(tab.show[0]) || (isOwnProfile && hasAccess(tab.show[1]));
        }

        return hasAccess(tab.show);
    });
}
